import { render } from "./LocatorListView.vue?vue&type=template&id=adc0c650&ts=true"
import script from "./LocatorListView.vue?vue&type=script&lang=ts"
export * from "./LocatorListView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__